import * as tus from 'tus-js-client';


export const uploadFileWithTUS = (file, bucketName, filePath, options = {}) => {
  const {
    onProgress = () => {},
    onSuccess = () => {},
    onError = () => {},
    projectUrl,
    getAccessToken
  } = options;

  if (!getAccessToken) {
    console.error('TUS upload requires getAccessToken function');
    onError(new Error('No getAccessToken function provided.'));
    return;
  }

  // Construct the TUS endpoint
  const tusEndpoint = `${projectUrl}/storage/v1/upload/resumable`;

  const upload = new tus.Upload(file, {
    endpoint: tusEndpoint,
    retryDelays: [0, 3000, 5000, 10000, 20000], // Retry delays in ms
    chunkSize: 6 * 1024 * 1024, // 6MB chunks (Supabase recommended)
    metadata: {
      bucketName: bucketName,
      objectName: filePath,
      contentType: file.type,
      cacheControl: '3600',
    },
    // Use onBeforeRequest to get fresh token for each request
    // This prevents token expiration during long uploads
    onBeforeRequest: async function (req) {
      const token = await getAccessToken();
      req.setHeader('Authorization', `Bearer ${token}`);
      req.setHeader('x-upsert', 'false');
    },
    onError: function (error) {
      console.error('TUS upload failed:', error);
      console.error('Error response:', error.originalResponse);
      onError(error);
    },
    onProgress: function (bytesUploaded, bytesTotal) {
      const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
      onProgress(parseFloat(percentage), bytesUploaded, bytesTotal);
    },
    onSuccess: function () {
      console.log('TUS upload completed successfully');
      
      // Construct the public URL
      const publicUrl = `${projectUrl}/storage/v1/object/public/${bucketName}/${filePath}`;
      onSuccess(publicUrl);
    },
  });

  // Start the upload
  upload.start();

  return upload; // Return the upload instance so it can be controlled externally
};

/**
 * Standard upload for small files (< 6MB)
 * @param {Object} supabase - Supabase client
 * @param {string} bucketName - Storage bucket name
 * @param {string} filePath - File path in bucket
 * @param {File} file - File to upload
 * @param {Object} options - Upload options
 * @returns {Promise} Upload result
 */
export const uploadFileStandard = async (supabase, bucketName, filePath, file, options = {}) => {
  return await supabase.storage
    .from(bucketName)
    .upload(filePath, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type,
      ...options,
    });
};

